import * as React from "react"
import type { SVGProps } from "react"
const SvgBookmarks = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m10 19.57-4.55 2.28a1 1 0 0 1-.97-.04 1 1 0 0 1-.48-.86V8.57q0-.83.59-1.41A2 2 0 0 1 6 6.57h8q.83 0 1.41.59.6.59.59 1.41v12.38q0 .57-.48.86a1 1 0 0 1-.97.04zm-4-.02 3.05-1.65a2 2 0 0 1 1.9 0L14 19.55V8.57H6zm13-.98a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.7v-13H8a1 1 0 0 1-.71-.3A1 1 0 0 1 7 3.57q0-.42.29-.71A1 1 0 0 1 8 2.57h10q.83 0 1.41.59.6.59.59 1.41v13q0 .42-.29.71a1 1 0 0 1-.71.29" />
  </svg>
)
export default SvgBookmarks
